export const STATUS_THIRD_PARTY =
  'CLIENT_PURSE_OWNER_CLASSIFICATION_STATUS_THIRD_PARTY'
export const STATUS_OWNER = 'CLIENT_PURSE_OWNER_CLASSIFICATION_STATUS_OWNER'

export const ALL_OPTIONS_STATUS = [
  {
    value: STATUS_OWNER,
    label: 'Own',
  },
  {
    value: STATUS_THIRD_PARTY,
    label: 'Third party',
  },
]

export const STATUS_THIRD_PARTY_BE = 'OWNER_CLASSIFICATION_STATUS_THIRD_PARTY'

export const STATUS_OWNER_BE = 'OWNER_CLASSIFICATION_STATUS_OWNER'
